const GameWorlds = () => (
  <section className="section section--alt" id="play">
    <div className="section__intro">
      <p className="eyebrow">Game worlds</p>
      <h2>Starting with maths. Expanding to everything.</h2>
    </div>
    <div className="grid grid--two">
      <article className="realm">
        <div className="realm__badge">Maths</div>
        <h3>Littlewood</h3>
        <p>
          Your friendly neighbourhood where you can explore and learn maths on the farm.
        </p>
      </article>
      <article className="realm">
        <div className="realm__badge">Maths</div>
        <h3>Margam Market</h3>
        <p>
          A cosy market where each stall teaches maths through stories and puzzles.
        </p>
      </article>
      <article className="realm realm--soon">
        <div className="realm__badge realm__badge--soon">Coming soon</div>
        <h3>Helper's Hollow</h3>
        <p>Learn civic responsibility and how to help the environment.</p>
      </article>
      <article className="realm realm--soon">
        <div className="realm__badge realm__badge--soon">Coming soon</div>
        <h3>Sprout Museum</h3>
        <p>History and art quests, plus a pixel art gallery for submissions.</p>
      </article>
    </div>
  </section>
);

export default GameWorlds;
